import React from 'react';
import Table from '../Table';
import Button from '../Button';
import { PreviewHeaderProps } from '../PreviewHeader';

/**
 * プレビュー画面 中カテゴリのProps定義
 */
export type PreviewMiddleCategoryHeaderProps = PreviewHeaderProps;

/**
 * プレビュー画面 カテゴリヘッダーコンポーネント
 *
 * ※必ずTableタグ内で使用して下さい
 */
const PreviewMiddleCategoryHeader = ({ title, uniqueId, editInfo = undefined }: PreviewMiddleCategoryHeaderProps) => {
  return (
    <Table.THead className='preview-table__thead'>
      <Table.Tr>
        <Table.Th colSpan={2} className='preview-table__th headline-5' data-testid={uniqueId} data-testid-e2e={uniqueId}>
          <div className='u-float-left u-h100p vertical-align-area-parent'>
            <div className='vertical-align-area-child'>
              <p>{title}</p>
            </div>
          </div>
          {editInfo && (
            <div className='u-float-right u-h100p vertical-align-area-parent'>
              <div className='vertical-align-area-child'>
                <Button
                  type='transparent'
                  leftIcon='edit'
                  iconClassName='u-text-white'
                  label={editInfo.label}
                  labelClassName='u-text-white'
                  onClick={() => editInfo.onClickEditHandler()}
                  data-testid={`edit-btn-on-${uniqueId}`}
                  data-testid-e2e={`edit-btn-on-${uniqueId}`}
                />
              </div>
            </div>
          )}
        </Table.Th>
      </Table.Tr>
    </Table.THead>
  );
};

export default PreviewMiddleCategoryHeader;
